/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_PaywallInputs */

const en_admin_funnel_card_paywall = /** @type {(inputs: Admin_Funnel_Card_PaywallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saw paywall today`)
};

/**
* | output |
* | --- |
* | "Saw paywall today" |
*
* @param {Admin_Funnel_Card_PaywallInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_paywall = /** @type {((inputs?: Admin_Funnel_Card_PaywallInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_PaywallInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_paywall(inputs)
});
export { admin_funnel_card_paywall as "admin.funnel.card.paywall" }